import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ArrowIcon from '../../../../public/static/icons/navigation-chevron-down.svg';

import styles from './index.module.scss';

const SuggestedSearches = ({ options, onOptionClick, className = '' }) => {
  // After a partial address is searched for, a dropdown appears with a list of
  // addresses. By default, the first option in the list is focused and
  // highlighted, which causes UX issues. See
  // https://www.pivotaltracker.com/story/show/185595667. To prevent this
  // happening we focus and then blur the info message that appears before the
  // list of addresses so that the location of the tab in the document is
  // appropriate without of the first item being focused.
  useEffect(() => {
    // Get the close info message element.
    const closeInfoMessage = document.getElementById('address-autocomplete-ie-info-message-close');
    // If we have the element, focus on it and then blur.
    if (closeInfoMessage) {
      closeInfoMessage.focus();
      closeInfoMessage.blur();
    }
  }, [options]);

  return (
    <ul
      className={`${styles['suggested-searches']} ${className}`}
      data-component="address-autocomplete-suggested"
    >
      {options.map((option) => (
        <li
          key={`${option.title}-${option.addressId}`}
          tabIndex={0}
          className={styles['suggested-searches__item']}
          onClick={(e) => {
            onOptionClick(option);
          }}
          onKeyDown={(e) => e.key === 'Enter' && onOptionClick(option)}
          data-component="address-autocomplete-suggested-item"
          data-hj-suppress
        >
          {option.title}
          <ArrowIcon className={styles['suggested-searches__arrow']} />
        </li>
      ))}
    </ul>
  );
};

SuggestedSearches.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      addressId: PropTypes.number,
    }),
  ).isRequired,
  className: PropTypes.string,
  onOptionClick: PropTypes.func.isRequired,
};

export default SuggestedSearches;
